import React from 'react';
import PropTypes from 'prop-types';
import { merge } from 'lodash';
import Vega from 'react-vega';
import { useTheme, vegaDarkTheme } from 'constants/theme';

const GeospatialLegends = React.memo(({ spec: { legends }, data }) => {
  const theme = useTheme();
  const _parseError = err => {
    // eslint-disable-next-line no-console
    console.error(`Vega failed to render due to a parseError. ${err}`);
  };
  const spec = merge(
    {},
    legends,
    theme === 'dark' ? { config: vegaDarkTheme } : {}
  );

  return (
    <div>
      <Vega
        spec={spec}
        data={data}
        renderer="canvas"
        onParseError={_parseError}
      />
    </div>
  );
});

GeospatialLegends.propTypes = {
  data: PropTypes.shape({
    documents: PropTypes.array,
    metadata: PropTypes.object,
  }).isRequired,
  spec: PropTypes.object.isRequired,
};

export default GeospatialLegends;
export { GeospatialLegends };
